export default __webpack_public_path__ + "static/media/IconNurse.cbe612dd.svg";